import {useEffect} from 'react';
import {useActions} from '@nl/ui';
import {isUndefined} from 'lodash';
import {shallowEqual, useSelector} from 'react-redux';
import usePrevious from './usePrevious';
import {resetPersonalContent} from '../store/actions/personal';
import {resetFavTeam} from '../store/actions/favteam';
import {resetFavVideos} from '../store/actions/favorite';
import {resetHistory} from '../store/actions/history';
import {resetRecommended} from '../store/actions/recommended';

const useResetPersonal = () => {
	const [resetPersonalContentAction, resetFavTeamAction] = useActions([resetPersonalContent,
		resetFavTeam]);
	const {
		uid,
	} = useSelector(
			(state) => ({
				uid: state.client.data.uid,
			}),
			shallowEqual,
	);

	const preUid = usePrevious(uid);

	useEffect(() => {
		if (!isUndefined(preUid) && preUid !== null && preUid !== uid) {
			resetPersonalContentAction();
			resetFavTeamAction();
			resetFavVideos();
			resetHistory();
			resetRecommended();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uid]);
};

export default useResetPersonal;
